/** Shared option lists for the Ultimate Scope Sheet */

export const PROPERTY_TYPES = ['Apartment', 'Villa', 'Farmhouse'];
export const UNIT_TYPES = ['1BHK', '2BHK', '3BHK', '4BHK', '5BHK'];
export const WINDOW_TYPES = ['Sliding', 'Openable', 'Fixed'];

export const SERVICES_REQUIRED = [
  'Full Home Renovation',
  'Interior Fit-Out',
  'Civil + Interior Turnkey',
  'Online Design Only',
  'Material Selection Support',
  'Project Management',
  'Furniture + Styling',
  'Vastu Consultation',
];

export const PROJECT_DELIVERABLES = [
  '2D Layouts',
  'Furniture Layout',
  'Electrical Layout',
  'Plumbing Layout',
  'Ceiling Layout',
  'Tile Layout',
  'Working Drawings',
  '3D Renders',
  'Material Boards',
  'BOQ',
  'Site Visits',
  'Vendor Coordination',
  'Procurement Support',
  'Final Styling',
  'Photoshoot',
];

export const CIVIL_ITEMS = [
  'Demolition of flooring',
  'Demolition of walls',
  'New partitions / wall shifting',
  'Floor leveling / screeding',
  'New flooring installation',
  'Skirting installation',
  'Beam/column covering',
  'Window enlargement/reduction',
  'Door shifting / Door Enlargement / Add Extra Door',
];

export const FALSE_CEILING_TYPES = ['POP', 'Wooden', 'Stretch', 'Grid'];
export const COVE_LIGHTING_OPTIONS = [
  'Outside Cove Only',
  'Inside Cove Only',
  'Inside + Outside Cove',
];
export const CEILING_DESIGN_OPTIONS = [
  'Grooves',
  'Mouldings',
  'Beam Covering',
  'No Design',
];

export const FLOOR_COVERING = ['Gloss Tile / Matt Tile', 'Marble', 'Granite'];
export const WALL_PANEL_MATERIALS = [
  'POP Design',
  'Laminate',
  'Veneer',
  'PU Coated',
  'Fabric Wrapped',
  'Glass',
  'Acrylic',
  'Stone Cladding',
  'Stone',
];

export const HARDWARE_LEVELS = [
  'Basic (Local Indian Brands)',
  'Mid (Hettich India / Ozone / Inox)',
  'Premium (Hafele / Hettich Germany)',
  'Ultra Premium (Blum Soft-Close)',
];

export const WIRING_BRANDS = ['Havells', 'Polycab', 'Finolex', 'Local'];
export const WIRE_TYPES = ['FR', 'FRLS', 'Non-FR'];
export const SWITCH_BRANDS = [
  'Anchor Roma',
  'GM',
  'Legrand Myrius',
  'Schneider Norysis',
  'Premium Smart Switches',
];
export const LIGHT_CATEGORIES = [
  'COB',
  'Downlights',
  'Panel Lights',
  'Profile Lights',
  'Cove Lights',
];
export const AUTOMATION_ITEMS = [
  'Lights',
  'Curtains',
  'AC',
  'TV',
  'Speakers',
  'Scene Settings',
];
export const AC_TYPES = ['Split', 'Cassette', 'Ductable'];
export const PAINT_OPTIONS = [
  'Royale Shine',
  'PU',
  'Texture',
  'Royale Matt',
  'Satin',
  'Plastic Premium',
];

export const CURTAIN_OPTIONS = ['Sheer Only', 'Blackout Only', 'Sheer + Blackout'];
export const WINDOW_COVERING = ['Blinds', 'Curtains'];
export const BALCONY_DOOR_TYPES = [
  'Sliding',
  'Hinged Single',
  'Hinged Double',
  'Fixed',
];
export const BALCONY_RAILING = [
  'Brick',
  'Glass',
  'Aluminium + Glass',
  'SS',
  'MS',
  'Other',
];

export const YES_NO = ['Yes', 'No'];

export const WASHROOM_CIVIL = [
  'Waterproofing',
  'Replace Fittings Only',
  'Full Demolition',
  'Drain Pipe Change',
  'Supply Pipe Change',
];
export const WALL_COVERINGS_BATH = ['Tile', 'Marble', 'Granite', 'Feature Tile'];
export const FLOOR_COVERINGS_BATH = ['Anti-Skid Tile', 'Marble', 'Granite'];
export const BASIN_TYPES = [
  'Over-Counter',
  'Under-Counter',
  'Table-Top',
  'Integrated',
  'Wall-Mounted',
];
export const SHOWER_TYPES = [
  'Wall-Mounted',
  'Ceiling-Mounted',
  'Shower Panel',
  'Body Jets',
];
export const FITTING_BRANDS = [
  'Cera',
  'Hindware',
  'Jaquar',
  'Kohler',
  'Grohe',
  'Hansgrohe',
  'Other',
];
export const PLUMBING_BRANDS = ['Astral', 'Supreme', 'Prakash', 'Ashirvad'];

export const WARDROBE_TYPES = ['Normal Wardrobe', 'Walk-In Wardrobe'];
/** Must match ultimate-scope template options exactly (space before ft). */
export const WARDROBE_HEIGHTS = ['Full Height', '8 ft', '8 ft + Loft'];
export const WARDROBE_INTERNALS = [
  'Hanging Rod',
  'Hanging Pullout',
  'Shelves',
  'Drawers',
  'Shoe Rack',
  'Trouser Pullout',
  'Tie Rack',
  'Jewellery Tray',
  'Mirror Inside',
  'Sensor Light',
];

export const KITCHEN_CONSTRUCTION = [
  'On-Site Carpenter',
  'Carcass On-Site + Factory-Made Shutters',
  'Full Modular Factory-Made Kitchen',
];
export const CARCASS_MATERIAL = [
  'HDHMR',
  'BWP Below Sink Only',
  'BWP Entire Kitchen',
  'Plywood (BWR/BWP)',
];
export const SHUTTER_FINISH = ['Laminate', 'Acrylic', 'PU', 'Veneer', 'Glass'];
export const COUNTER_MATERIAL = ['Granite', 'Quartz', 'Marble'];
export const KITCHEN_FITTINGS = [
  'Corner Unit',
  'Tandem Drawers',
  'Bottle Pullout',
  'Pantry Unit',
  'Rolling Shutter',
  'Cutlery Tray',
  'Grain Trolley',
  'Wicker Basket',
  'Integrated Dustbin',
  'Glass Tray / Plate Tray',
];
export const HEAVY_APPLIANCES = [
  'Hob Point',
  'Chimney + Duct Route',
  'Microwave',
  'Oven',
  'Refrigerator',
  'Dishwasher Electrical Point',
  'Exhaust',
  'Aquaguard / RO',
];
export const RO_LOCATION = ['Under-Sink', 'Over-Head'];
